<account-back class="m-b-9 m-b-7-s m-b-7-m m-t--1 block p-l-2"
[title]="'Account details' | translate"></account-back>

<div [grid]="client.sizeId > 1 ? 2 : 1"
  [gridColumnGap]="'20px'"
  [gridRowGap]="client.sizeId > 1 ? '20px' : '24px'">

  <!-- personal -->
  <section2 [gridColumn]="1"
    [title]="'Personal details'"
    [icon]="'account'"
    [linkCopy]="'Edit'"
    [link]="'/account/edit/personal'">
    <p class="p1 col-12 p-t p-t-0-s">{{customer.model.data| customerName}}</p>
  </section2>


  <!-- email address -->
  <section2 [gridColumn]="1"
    [title]="'Email address'"
    [icon]="'email'"
    [linkCopy]="'Edit'"
    [link]="'/account/edit/email'">
    <p class="p1 col-12 p-t p-t-0-s truncate">{{customer.model.data.email}}</p>
  </section2>


  <!-- personal -->
  <section2 [gridColumn]="1"
    [title]="'Password'"
    [icon]="'lock'"
    [linkCopy]="'Edit'"
    [link]="'/account/edit/password'">
    <p class="p1 col-12 p-t p-t-0-s">••••••••••••</p>
  </section2>

  <section2 [gridColumn]="1"
    [title]="'Preferred Store'"
    [icon]="'location'"
    [linkCopy]="'Edit'"
    [link]="'/account/edit/preferred-store'">
    @if (customer.model?.data?.preferred_store) {
      <p class="p1 col-12 p-t p-t-0-s"
        >
        {{customer.model.data.preferred_store | customerOptionLabel : 'preferred_store'}}
      </p>
    }
  </section2>
</div>
